import * as Yup from 'yup'

Yup.setLocale({
    mixed: {
        required: "This field is required."
    }
})

export default Yup